var render = function render(){var _vm=this,_c=_vm._self._c;return _c('number',{ref:"number1",attrs:{"from":_vm.from,"to":_vm.to,"format":_vm.theFormat,"duration":1,"easing":"Power1.easeOut"}})
}
var staticRenderFns = []

export { render, staticRenderFns }